export const lazyLoadingCop = file => require('@/view/' + file + '.vue').default


// WEBPACK FOOTER //
// ./src/libs/tools.js